import { LoadChildrenCallback, Routes } from '@angular/router';
import { withTranslations } from '../i18n/resolvers/translations.resolvers';

const homeEntrypoint: LoadChildrenCallback = () =>
    import('../home/presentation/routes/home-entrypoint.module').then(
        (m) => m.HomeEntrypointModule,
    );

export const homeRoutes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        loadChildren: homeEntrypoint,
        ...withTranslations('landing'),
    },
    {
        path: 'a/:system1/:system2',
        loadChildren: homeEntrypoint,
        ...withTranslations('landing'),
    },
    {
        path: 'b/:system1/:system2',
        loadChildren: homeEntrypoint,
        ...withTranslations('landing'),
    },
    {
        path: 'a/:system1/:system2/:amount1',
        loadChildren: homeEntrypoint,
        ...withTranslations('landing'),
    },
    {
        path: 'b/:system1/:system2/:amount1',
        loadChildren: homeEntrypoint,
        ...withTranslations('landing'),
    },
    {
        path: 'a/:system1/:system2/:amount1/:amount2',
        loadChildren: homeEntrypoint,
        ...withTranslations('landing'),
    },
    {
        path: 'b/:system1/:system2/:amount1/:amount2',
        loadChildren: homeEntrypoint,
        ...withTranslations('landing'),
    },
];
